import { FolderPlus } from "lucide-react";
import { useCreateFolder } from "../../hooks/queries";

// Create a root-level folder (Front-End.md §A10). Nested folders are created from a
// folder's own menu ("New subfolder").
export function NewFolderButton() {
  const createFolder = useCreateFolder();
  return (
    <button
      onClick={() =>
        createFolder.mutate({ name: "New folder", parentFolderId: null })
      }
      className="flex items-center gap-1.5 rounded px-2.5 py-1.5 text-[12px] text-muted hover:bg-hover hover:text-fg"
    >
      <FolderPlus size={14} /> New folder
    </button>
  );
}
